<template>
     <dialog-layout  ref="helpDialog" id="helpDialog" @click="dialogActions">
        <h3 slot="headercontent">{{$route.meta.title||'Help'}}</h3>  
        
        <div v-if="help" v-html="help.htmlcontent"></div> 
        <div v-if="!help || !help.htmlcontent">
            Sorry no help content available..
        </div> 

    </dialog-layout>  

</template>

<script>
import {mapActions,mapGetters} from "vuex";
export default {      
  data: function() {
    return {        
        meta:null,
        help:null,
        mapping:null
    };
  },
  computed: {      
      ...mapGetters(["config"])
  },
  methods: {        
    ...mapActions(["getHelpPage"]),
    show(){   
      //let clients know about      
      let path = this.$route.path
      path = path.split("/").join("_").substr(1)
      
      this.getHelpPage(path).then((content)=>{          
          this.help = content
          this.$refs.helpDialog.show()    
      })        
    },  
    dialogActions(e) {         
      if(e.action==='canceldialog')
      {        
        this.meta = null       
      }        
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/HelpDialog.vue